import { render, staticRenderFns } from "./teachingActivitiesOperate.vue?vue&type=template&id=9ac5f65e&scoped=true"
import script from "./teachingActivitiesOperate.vue?vue&type=script&lang=js"
export * from "./teachingActivitiesOperate.vue?vue&type=script&lang=js"
import style0 from "./teachingActivitiesOperate.vue?vue&type=style&index=0&id=9ac5f65e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac5f65e",
  null
  
)

export default component.exports